// extracted by mini-css-extract-plugin
export var container = "_tb-0";
export var table = "_tb-2";
export var tableWrapper = "_tb-1";